import { dashboardService } from '@/services/dashboard.service';
import { useOrganisationsStore } from '@/store/organisations.store';
import { DashboardStats } from '@/types/dashboard.types';
import { useQuery } from '@tanstack/react-query';

export const useDashboard = () => {
  const { currentOrganisation } = useOrganisationsStore();
  const organisationUuid = currentOrganisation?.uuid;

  return useQuery<DashboardStats>({
    queryKey: ['dashboard-stats', organisationUuid],
    queryFn: async () => {
      const response = await dashboardService.getDashboardStats();
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 10 * 60 * 1000, // 10 minutes
  });
};
